import Swal from "sweetalert2/dist/sweetalert2.js";

function _gcCookie(name) {
    const m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return m ? m.pop() : null;
}
function _gcSetCookie(name, value, seconds) {
    const d = new Date(Date.now() + seconds * 1000);
    document.cookie = `${name}=${value};expires=${d.toUTCString()};path=/`;
}
function _gcDelCookie(name) {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
}

const Store = {
    giftCart: window.PlUs.giftCart,
    cart: {
        items: [],
        totalItems: 0,
        total: 0,
        totalOutShippingCost: 0,
        subtotal: 0,
        subtotalPromo: 0,
        giftDiscount: 0,
        shippingCost: 0,
        shippingCostPromo: null,
        promoCode: null,
        promoCheck: false,
        currency: "EUR",
        country: {
            name: null,
            id: null,
            iso: null
        },
        scalapay: false
    },
    address: {
        list: [],
        choice: "person",
        companyName: "",
        company_name: "",
        taxCode: "",
        vatNumber: "",
        pecEmail: "",
        sdi: "",
        note: "",
        same: false,
        sameInvoice: false,
        alternative: {
            name: "",
            surname: "",
            company_name: "",
            address: "",
            zip_code: "",
            district: "",
            city: "",
            country: "",
            telephone: ""
        },
        alternativeChecked: false
    },
    checkout: {
        paymentMethod: null,
        paymentAddress: null,
        readAgree: false,
        overAge: false,
        showPaymantButton: false
    },
    debug: process.env.NODE_ENV === "development",
    /**
     * Ottinene il carrello del utente
     * @param {function} callback funzione a cui vengono passanti properties e products
     * @param {bool} loadingPage se true modifica la variabile loadingPage anzi che loading
     */
    async getCart() {
        if (this.debug) {
            console.log("@getCart", "async");
        }
        const api = this.giftCart
            ? window.PlUs.api.giftcart
            : window.PlUs.api.cart;
        try {
            const response = await window.axios.get(api);
            this.updateCart(
                response.data.data.properties,
                response.data.data.items
            );
        } catch (error) {
            console.error(error);
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: window.PlUs.strings["error"],
                footer: response.err
            });
        }
    },
    /**
     * Verifica se il carrello è vuolo e se non lo è aggiorna i dati
     * relativi ai costi di spedizione e aggiunge il promo_code se presente
     * @param {Object} properties
     * @param {Object} products
     */
    updateCart(properties, products) {
        this.cart.country = {
            name: properties.country_name,
            id: properties.countries_id,
            iso: properties.country_iso
        };
        this.cart.totalItems = properties.total_quantity;
        this.cart.currency = properties.currency;
        this.cart.shippingCost = properties.shipping_cost
            ? parseFloat(properties.shipping_cost)
            : 0;
        this.cart.shippingCostPromo =
            properties.shipping_cost != properties.shipping_cost_before_promo
                ? parseFloat(properties.shipping_cost_before_promo)
                : null;
        this.cart.giftDiscount = properties.gift_discount
            ? parseFloat(properties.gift_discount)
            : 0;
        this.cart.promoCheck =
            properties.promo_code != null && properties.promo_code != "";
        this.cart.promoCode =
            properties.promo_code === undefined || properties.promo_code === ""
                ? null
                : properties.promo_code;
        this.cart.scalapay = properties.scalapay;
        this.cart.list_valid = properties.list_valid;
        if (properties.user_invoice_address_id != null) {
            this.checkout.paymentAddress = properties.user_invoice_address_id;
        }
        if (properties.payments_id != null) {
            this.checkout.paymentMethod = properties.payments_id;
        }

        // Aggirno i prodotti
        this.cart.items = [];
        if (Object.keys(products).length > 0) {
            let itemList = products;
            Object.keys(itemList).forEach(key => {
                itemList[key]["product_version"] = key;
                itemList[key]["updating"] = false;
                this.cart.items.push(itemList[key]);
            });
        }
        // Aggiorno totale prodotti
        this.cart.totalItems = this.cart.items.length;
        if (this.debug) {
            console.log("@updateCart", this.cart, properties, products);
        }
        this.calculateCost();
    },
    calculateCost() {
        if (this.debug) {
            console.log("@calculateCost", this.cart);
        }
        let subtotal = 0;
        let subtotalPromo = 0;
        let total = 0;
        let totalMini = 0;
        if (this.cart.items.length > 0) {
            this.cart.items.forEach(element => {
                subtotal += parseFloat(
                    element.attributes.price * element.quantity
                );
            });
            if (this.cart.promoCheck) {
                subtotalPromo = subtotal;
                this.cart.items.forEach(element => {
                    subtotalPromo -=
                        element.attributes.price * element.quantity;
                });
            }
        }
        total =
            (this.cart.promoCheck ? subtotal - subtotalPromo : subtotal) +
            this.cart.shippingCost -
            this.cart.giftDiscount;
        if (total < 0) total = 0;
        totalMini = this.cart.promoCheck ? subtotal - subtotalPromo : subtotal;

        this.cart.subtotal = subtotal;
        this.cart.subtotalPromo = Math.round(subtotalPromo);
        this.cart.total = total;
        this.cart.totalOutShippingCost = totalMini;
    },
    /**
     * Rimuove dal carrello un prodotto, se nella chiamata API viene
     * passato il parametro all a true allora l'API rimuove tutti
     * i gli SKU con quel id dal carrello
     * @param {integer} key
     * @param {string} currency
     */
    async removeItem(key, currency) {
        if (this.debug) {
            console.log("@removeItem", "async", key);
        }
        const product = this.cart.items[key];
        let productVersion = product.product_version;
        let indexList = 0;

        this.cart.items.forEach((element, index) => {
            if (productVersion == element.product_version) {
                element.updating = true;
                indexList = index;
            }
        });
        const api = this.giftCart
            ? window.PlUs.api.giftcart
            : window.PlUs.api.cart;
        try {
            const response = await window.axios.delete(
                api + "/" + productVersion,
                {
                    params: {
                        all: true
                    }
                }
            );
            if (this.debug) {
                console.log("@removeItem response", response);
            }
            if (response.data.data.removed) {
                this.cart.totalItems = response.data.data.quantity;
                this.cart.items[indexList].quantity -= 1;
                if (this.cart.items[indexList].quantity <= 0) {
                    this.cart.items.splice(indexList, 1);
                }
                let totaldiscount = 0;
                totaldiscount =
                    product["attributes"].discount > 0
                        ? product["attributes"].price_original -
                          product["attributes"].price
                        : 0;

                dataLayer.push({
                    event: "removeFromCart",
                    eventCategory: "Ecommerce",
                    eventAction: "Remove from Cart",
                    ecommerce: {
                        currencyCode: currency,
                        remove: {
                            products: [
                                {
                                    name: product["ga4"].name,
                                    id:
                                        product["attributes"]
                                            .product_version_id,
                                    price: product["attributes"].price,
                                    brand: "Pollini",
                                    category: product["ga4"].category,
                                    category2: product["ga4"].category2,
                                    category3: product["ga4"].category3,
                                    category4: product["ga4"].category4,
                                    category5: product["ga4"].category5,
                                    variant: product["ga4"].color,
                                    quantity: 1,
                                    full_price:
                                        product["attributes"].price_original,
                                    discount: totaldiscount,
                                    discount_rate:
                                        product["attributes"].discount
                                }
                            ]
                        }
                    }
                });
            }
            this.calculateCost();
        } catch (err) {
            console.error(err);
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: window.PlUs.strings["error"],
                footer: err
            });
        }
    },
    /**
     * Aggiorna il numero di prodotti a carrello di +1 o -1
     * @param {integer} key sku del prodotto
     * @param {string} action azione add o remove
     */
    async updateItem(key, action) {
        if (this.debug) {
            console.log("@updateItem", "async", key, action);
        }
        const product = this.cart.items[key];
        let productVersion = this.cart.items[key].product_version;
        let indexList = 0;
        let attributes = null;
        let uniqueid = uuidv4();

        this.cart.items.forEach((element, index) => {
            if (productVersion == element.product_version) {
                element.updating = true;
                indexList = index;
                attributes = element;
            }
        });
        const api = this.giftCart
            ? window.PlUs.api.giftcart
            : window.PlUs.api.cart;
        try {
            const response = await window.axios.put(
                api + "/" + productVersion,
                {
                    action: action == "add" ? "add" : "remove"
                }
            );
            if (this.debug) {
                console.log("@updateItem response", response);
            }
            if (response.data.data.message != "") {
                Swal.fire({
                    icon: "info",
                    title: "Spiacente",
                    text: response.data.data.message
                });
            } else if (action == "add" && response.data.data.added) {
                if (!this.debug) {
                    // FACEBOOK
                    fbq(
                        "track",
                        "AddToCart",
                        {
                            value: attributes.price,
                            currency: attributes.currency,
                            content_ids: "['" + productVersion + "']",
                            content_type: "product_group"
                        },
                        { eventID: uniqueid }
                    );
                    // GOOGLE
                    gtag("event", "add_to_cart", {
                        send_to: "AW-795664375",
                        dynx_itemid: productVersion,
                        dynx_pagetype: "offerdetail",
                        dynx_totalvalue:
                            attributes.price + " " + attributes.currency
                    });
                    //PINTEREST
                    pintrk("track", "AddToCart", {
                        product_id: productVersion,
                        value: attributes.price,
                        event_id: uniqueid,
                        order_quantity: 1,
                        currency: attributes.currency
                    });
                }

                location.reload();
            } else if (action == "remove" && response.data.data.removed) {
                if (this.debug) {
                    console.log(
                        "@rimosso prodotto dal carrello, parte GA4 removeItem",
                        response
                    );
                }
                let totaldiscount = 0;
                totaldiscount =
                    product["attributes"].discount > 0
                        ? product["attributes"].price_original -
                          product["attributes"].price
                        : 0;

                dataLayer.push({
                    event: "removeFromCart",
                    eventCategory: "Ecommerce",
                    eventAction: "Remove from Cart",
                    ecommerce: {
                        currencyCode: attributes.currency,
                        remove: {
                            products: [
                                {
                                    name: product["ga4"].name,
                                    id:
                                        product["attributes"]
                                            .product_version_id,
                                    price: product["attributes"].price,
                                    brand: "Pollini",
                                    category: product["ga4"].category,
                                    category2: product["ga4"].category2,
                                    category3: product["ga4"].category3,
                                    category4: product["ga4"].category4,
                                    category5: product["ga4"].category5,
                                    variant: product["ga4"].color,
                                    quantity: 1,
                                    full_price:
                                        product["attributes"].price_original,
                                    discount: totaldiscount,
                                    discount_rate:
                                        product["attributes"].discount
                                }
                            ]
                        }
                    }
                });
                location.reload();
            }
            this.updateCart(
                response.data.data.cart.properties,
                response.data.data.cart.items
            );
        } catch (err) {
            console.error(err);
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: window.PlxUs.strings["error"],
                footer: err
            });
        }
    },
    /**
     * Aggiunge un prodotto il carrello, vengo passati anche paramentri
     * aggiuntivi per le api di google e facebook
     * @param {integer} productVersion
     * @param {string} price
     * @param {string} currency
     * @param {integer} productId
     * @param {function} calltoaction
     */
    async addItem(skuId, price, currency, productId, calltoaction) {
        let uniqueid = uuidv4();
        let fbc_cookie = getCookie("_fbc");
        let fbp_cookie = getCookie("_fbp");

        if (this.debug) {
            console.log(
                "@addItem",
                "async",
                skuId,
                price,
                currency,
                productId,
                calltoaction
            );
        }
        const api = this.giftCart
            ? window.PlUs.api.giftcart
            : window.PlUs.api.cart;
        try {
            const response = await window.axios.post(api, {
                id: skuId
            });
            if (this.debug) {
                console.log("@addItem response", response);
            }
            if (response.data.data.added) {
                const properties = response.data.data.cart.properties;
                const products = response.data.data.cart.items;
                this.updateCart(properties, products);
                if (!this.debug) {
                    // FACEBOOK
                    fbq(
                        "track",
                        "AddToCart",
                        {
                            value: price,
                            currency: currency,
                            content_ids:
                                "['" +
                                products[skuId]["attributes"]
                                    .product_version_id +
                                "']",
                            content_type: "product_group"
                        },
                        { eventID: uniqueid }
                    );
                    // GOOGLE
                    gtag("event", "add_to_cart", {
                        send_to: "AW-795664375",
                        dynx_itemid:
                            products[skuId]["attributes"].product_version_id,
                        dynx_pagetype: "offerdetail",
                        dynx_totalvalue: price + " " + currency
                    });
                    //BING
                    if (typeof uet_report_conversion === "function") {
                        uet_report_conversion();
                    }
                }

                let quickclass = window.Quicktrue;

                if (this.debug) {
                    console.log(quickclass);
                    console.log(products[skuId]["ga4"].category);
                    console.log(products[skuId]["ga4"].category3);
                }

                //GA4
                let totaldiscount = 0;
                totaldiscount =
                    products[skuId]["attributes"].discount > 0
                        ? products[skuId]["attributes"].price_original -
                          products[skuId]["attributes"].price
                        : 0;

                dataLayer.push({
                    event: "addToCart",
                    eventCategory: "Ecommerce",
                    eventAction: "Add to Cart",
                    quickbuy: quickclass == 1 ? "true" : "false",
                    eventID: uniqueid,
                    "x-fb-ck-fbc": fbc_cookie,
                    "x-fb-ck-fbp": fbp_cookie,
                    ecommerce: {
                        currencyCode: currency,
                        add: {
                            products: [
                                {
                                    name: products[skuId]["ga4"].name,
                                    id:
                                        products[skuId]["attributes"]
                                            .product_version_id,
                                    price: products[skuId]["attributes"].price,
                                    brand: "Pollini",
                                    category: products[skuId]["ga4"].category,
                                    category2: products[skuId]["ga4"].category2,
                                    category3: products[skuId]["ga4"].category3,
                                    category4: products[skuId]["ga4"].category4,
                                    category5: products[skuId]["ga4"].category5,
                                    variant: products[skuId]["ga4"].color,
                                    quantity: 1,
                                    full_price:
                                        products[skuId]["attributes"]
                                            .price_original,
                                    discount: totaldiscount,
                                    discount_rate:
                                        products[skuId]["attributes"].discount
                                }
                            ]
                        }
                    }
                });
                //PINTEREST
                pintrk("track", "AddToCart", {
                    product_id:
                        products[skuId]["attributes"].product_version_id,
                    value: price,
                    order_quantity: 1,
                    event_id: uniqueid,
                    currency: currency
                });
                if (typeof calltoaction === "function") {
                    calltoaction();
                }
                $("html, body").animate(
                    {
                        scrollTop: 0
                    },
                    "fast"
                );
                this.cart.totalItems = response.data.data.quantity;
            } else if (response.data.data.message !== "") {
                Swal.fire({
                    icon: "info",
                    title: response.data.data.message
                });
            }
            this.calculateCost();
        } catch (err) {
            console.error(err);
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: window.PlUs.strings["error"],
                footer: err
            });
        }
    },
    /**
     * Aggiunge al carrello una promo/coupon
     * @param {string} promo
     */
    async addPromo(promo) {
        if (this.debug) console.log("@addPromo", promo);
        if (!promo) return;

        if (_gcCookie('gc_blocked')) {
            Swal.fire({
                icon: "error",
                title: "Attenzione",
                text: window.PlUs.strings["giftcard_rate_limit"] || "Troppi tentativi. Riprova tra 10 minuti."
            });
            return;
        }

        const api = this.giftCart
            ? window.PlUs.api.giftdiscount
            : window.PlUs.api.discount;

        try {
            const response = await window.axios.post(api, { promo });
            if (this.debug) console.log("@addPromo response", response);

            const data = response?.data?.data || {};
            const cart = data.cart || {};
            const properties = cart.properties || {};
            const products = cart.items || {};

            // ✅ Verifica se il codice è realmente applicato
            const promoApplied =
                properties.promo_code && properties.promo_code !== "";

            if (!promoApplied) {
                // ❌ Codice NON applicato → incremento il contatore tentativi
                const attempts = parseInt(_gcCookie('gc_attempts') || '0') + 1;
                if (attempts >= 10) {
                    _gcSetCookie('gc_blocked', '1', 600);
                    _gcDelCookie('gc_attempts');
                } else {
                    _gcSetCookie('gc_attempts', attempts, 3600);
                }

                const msg =
                    data.message && data.message !== ""
                        ? data.message
                        : window.PlUs.strings["promo_error"];
                Swal.fire({
                    icon: "error",
                    title: "Attenzione",
                    text: msg
                });
                return;
            }

            // ✅ Codice applicato correttamente → azzero il contatore
            _gcDelCookie('gc_attempts');
            this.updateCart(properties, products);

            if (properties.promo_warning) {
                Swal.fire({
                    icon: "info",
                    title: "Info",
                    text: window.PlUs.strings["promo_warning"]
                });
            }
        } catch (error) {
            console.error(error);
            const msg =
                error?.response?.data?.data?.message ||
                window.PlUs.strings["error"];
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: msg
            });
        }
    },
    /**
     * Rimuove dal carrello la promo impostata
     */
    async deletePromo() {
        if (this.debug) {
            console.log("@deletePromo", "async");
        }
        this.loadingPage = true;
        const api = this.giftCart
            ? window.PlUs.api.giftdiscount
            : window.PlUs.api.discount;
        try {
            const response = await window.axios.delete(
                api + "/" + this.cart.promoCode
            );
            if (this.debug) {
                console.log("@deletePromo response", response);
            }
            const properties = response.data.data.cart.properties;
            const products = response.data.data.cart.items;
            this.updateCart(properties, products);
            this.cart.promoCheck = false;
        } catch (err) {
            console.error(err);
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: window.PlUs.strings["error"],
                footer: err
            });
        }
    },
    /**
     * Setta l'id dell' indirizzo che si vuole usare
     * @param {integer} val
     */
    async setAddress(val) {
        if (this.debug) {
            console.log("@setAddress", "async", val, this.cart.currency);
        }
        await this.setAddressInvoice(val);
    },
    /**
     * Salva nel carrello in sessione e a db l'indirizzo della fattura
     * se tutto va a buon fine controlla che il country di quello selezionato
     * sia uguale a quello del carrelo, in caso controrio lancia la
     * funzione chechSummary che ricarica il carrllo
     * @param {integer} id
     */
    async setAddressInvoice(id) {
        if (this.debug) {
            console.log("@setAddressInvoice", "async", id);
        }
        const address = this.address.list.find(x => x.id == id);
        const api = this.giftCart
            ? window.PlUs.api.giftcart
            : window.PlUs.api.cart;
        try {
            const response = await window.axios.put(api + "/" + id, {
                action: "set-address-invoice",
                name: address.name,
                surname: address.surname,
                // Set company_name from the selected address if present, fall back to the top-level invoice field
                company_name:
                    address.company_name || this.address.companyName || "",
                // Support both the stored address snake_case and top-level camelCase fields for invoice-specific fields
                vat_number: address.vat_number || this.address.vatNumber || "",
                tax_code: address.tax_code || this.address.taxCode || "",
                pec_email: address.pec_email || this.address.pecEmail || "",
                codice_univoco_fatturazione:
                    address.codice_univoco_fatturazione ||
                    this.address.sdi ||
                    "",
                invoice: this.address.sameInvoice
            });
            if (this.debug) {
                console.log("@setAddressInvoice", response);
            }
            this.updateCart(
                response.data.data.cart.properties,
                response.data.data.cart.items
            );
            // Update top-level address invoice fields to reflect the selected address
            this.address.companyName =
                address.company_name || this.address.companyName || "";
            // Keep the snake_case counterpart if other code expects it
            this.address.company_name =
                address.company_name || this.address.company_name || "";
            this.address.vatNumber =
                address.vat_number || this.address.vatNumber || "";
            this.address.taxCode =
                address.tax_code || this.address.taxCode || "";
            this.address.pecEmail =
                address.pec_email || this.address.pecEmail || "";
            // Set the current payment address id
            this.checkout.paymentAddress = id;
        } catch (err) {
            console.error(err);
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: window.PlUs.strings["error"],
                footer: err
            });
        }
    },
    /**
     * Setta l'id dell' indirizzo che si vuole usare
     * @param {integer} val
     */
    async setShippingAddress() {
        if (this.debug) {
            console.log("@setShippingAddress", "async");
        }
        await this.setAddressShipping();
    },
    /**
     * Salva nel carrello in sessione e a db l'indirizzo della fattura
     * se tutto va a buon fine controlla che il country di quello selezionato
     * sia uguale a quello del carrelo, in caso controrio lancia la
     * funzione chechSummary che ricarica il carrllo
     * @param {integer} id
     */
    async setAddressShipping() {
        if (this.debug) {
            console.log(
                "@setAddressShipping",
                "async",
                this.address.alternative
            );
        }
        try {
            // id = == per accedere alla funzione update delle API
            const response = await window.axios.put(
                window.PlUs.api.cart + "/00",
                {
                    action: "set-address-shipping",
                    name: this.address.alternative.name,
                    surname: this.address.alternative.surname,
                    company_name: this.address.alternative.company_name,
                    address: this.address.alternative.address,
                    zip_code: this.address.alternative.zip_code,
                    district: this.address.alternative.district,
                    city: this.address.alternative.city,
                    country: this.cart.country.id, // Uso il coutry del carrello in quanto non si può selezionare un'indirizzo di spedizione diverso dal country di fatturazione
                    telephone: this.address.alternative.telephone
                }
            );
            if (this.debug) {
                console.log("@setAddressInvoice", response);
            }
            this.updateCart(
                response.data.data.cart.properties,
                response.data.data.cart.items
            );
        } catch (err) {
            console.error(err);
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: window.PlUs.strings["error"],
                footer: err
            });
        }
    },
    async setMethodPayment(id) {
        if (this.debug) {
            console.log("@setMethodPayment", "async", id);
        }
        const api = this.giftCart
            ? window.PlUs.api.giftcart
            : window.PlUs.api.cart;
        try {
            // Aggiorno il metodo i pagamento con le API
            const response = await window.axios.put(api + "/" + id, {
                action: "set-payment"
            });
            this.checkout.paymentMethod = id;
            if (this.debug) {
                console.log("@setPayment response", response);
            }
            this.updateCart(
                response.data.data.cart.properties,
                response.data.data.cart.items
            );
        } catch (err) {
            console.error(err);
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: window.PlUs.strings["error"],
                footer: response.err
            });
        }
    },
    async removeMethodPayment(id) {
        if (this.debug) {
            console.log("@removeMethodPayment", "async", id);
        }
        const api = this.giftCart
            ? window.PlUs.api.giftcart
            : window.PlUs.api.cart;
        try {
            // Aggiorno il metodo i pagamento con le API
            const response = await window.axios.put(api + "/" + id, {
                action: "remove-payment"
            });
            this.checkout.paymentMethod = null;
            if (this.debug) {
                console.log("@removePayment response", response);
            }
            this.updateCart(
                response.data.data.cart.properties,
                response.data.data.cart.items
            );
        } catch (err) {
            console.error(err);
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: window.PlUs.strings["error"],
                footer: response.err
            });
        }
    },
    async changeMethodPayment(val) {
        if (this.debug) {
            console.log("@changeMethodPayment", "async", val);
        }
        if (val != null) {
            await this.setMethodPayment(val);
        } else {
            await this.removeMethodPayment(0);
        }
        this.checkout.showPaymantButton = false;
    }
};

export default Store;
